import { render } from "./scaledetailview.vue?vue&type=template&id=46fb296c"
import script from "./scaledetailview.vue?vue&type=script&lang=js"
export * from "./scaledetailview.vue?vue&type=script&lang=js"

import "./scaledetailview.vue?vue&type=style&index=0&id=46fb296c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__